import React from 'react';
import {ButtonBar, SaveButton, Field, Form, Option} from '../commons/Forms.js';
import {Pane, Part} from '../commons/Panes';
import {connect} from 'react-redux';
import {sendMessage} from '../../redux/messages/actions';
import { showPhone } from '../../utils';

import '../../styles/adminPanels.less';
import {MESSAGE_EXAMPLE} from '../../config';

/** Panneau d'envoi de messages factices */
@connect(
  state => ({groomers: state.groomers}),
  {sendMessage}
)
class QuickSend extends React.Component {

  onSubmit(e) {
    e.preventDefault();

    let data = {
      from: this.refs.phone.value(),
      content: this.refs.content.value(),
    };

    this.props.sendMessage(data);
    this.props.onEnd();
    return false;
  }

  render() {
    const {groomers} = this.props;
    return (
      <Pane title="Envoi de messages">
        <Part title="Message">
          <Form onSubmit={e => this.onSubmit(e)}>
            <Field ofType="select" label="Dameuse" required={true} ref="phone">
              {groomers.items.valueSeq().toJS().map(v => {
                return <Option key={v.id} value={showPhone(v.phone)} label={`${showPhone(v.phone)} (${v.code})`}/>
              })}
            </Field>
            <Field ofType="textarea" label="Contenu" required={true} ref="content"
            />
            <ButtonBar>
              <SaveButton />
            </ButtonBar>
          </Form>
        </Part>
        <Part title="Exemple (fonctionnel)">
          <pre>
            { MESSAGE_EXAMPLE }
          </pre>
        </Part>
      </Pane>
    )
  }
}

export default QuickSend;



// WEBPACK FOOTER //
// ./src/components/admin/Quicksend.js